export const criiptoBaseUrl: string = `
  https://${process.env.VUE_APP_EID_API_URL || 'eid.ga-staging.com'}
`;
